module.exports = __webpack_public_path__ + "img/bankkart.f5319f91.svg";